import React from "react";

export function PageHeader({ title, description, actions, breadcrumbs }) {
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between py-6 border-b border-border" data-testid="page-header">
      <div className="space-y-1.5">
        {breadcrumbs && <div className="text-xs text-muted-foreground">{breadcrumbs}</div>}
        <h1 className="text-2xl font-semibold tracking-tight" data-testid="page-title">{title}</h1>
        {description && (
          <p className="text-sm text-muted-foreground max-w-2xl" data-testid="page-description">{description}</p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2" data-testid="page-actions">{actions}</div>}
    </div>
  );
}
